'use client'
import { ReactNode, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface Props {
  children: ReactNode
  onClose: () => void
}

const ModalBase = ({ children, onClose }: Props) => {
  const [isVisible, setIsVisible] = useState(false)

  // Close modal on ESC key
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleEsc)

    // Delay to make the modal visible after mounted
    setIsVisible(true)

    return () => window.removeEventListener('keydown', handleEsc)
  }, [onClose])

  // Close modal with a fade out effect
  const handleClose = () => {
    setIsVisible(false)
    // Give a small delay to allow the fade-out effect to run before calling onClose
    setTimeout(onClose, 200)
  }

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-200 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={handleClose} // Close on overlay click
    >
      <div
        className={`bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative transform transition-all duration-200 ${
          isVisible ? 'scale-100' : 'scale-50'
        }`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {children}
      </div>
    </div>,
    document.body
  )
}

export default ModalBase
